import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AttachmentView } from '../../attachment-view.model';

@Component({
  selector: 'app-attachments-uploading-list-item',
  templateUrl: './attachments-uploading-list-item.component.html',
  styleUrls: ['./attachments-uploading-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentsUploadingListItemComponent implements OnInit {
  @Input() attachment: AttachmentView;

  @Output()
  onCancelAttachmentItem: EventEmitter<AttachmentView> = new EventEmitter<AttachmentView>();
  @Output()
  onRetryAttachmentItem: EventEmitter<AttachmentView> = new EventEmitter<AttachmentView>();

  constructor() {}

  ngOnInit() {}

  onCancel() {
    this.onCancelAttachmentItem.emit(this.attachment);
  }

  onRetry() {
    this.onRetryAttachmentItem.emit(this.attachment);
  }
}
